import { npsFilters } from '@/net-promoter-system/constants/nps.constants.js';
import { NPS_COLOR_MAP } from '@/common/chart/chart-colors';

export function computeNpsMarginOfError ({ promoters, passive, detractors, npsScore }) {
    // https://www.genroe.com/blog/how-to-calculate-margin-of-error-and-other-stats-for-nps
    // https://www.dummies.com/education/math/statistics/checking-out-statistical-confidence-interval-critical-values/
    const totalResponses = detractors + passive + promoters;
    if (totalResponses === 0) {
        return -1;
    }
    // eslint-disable-next-line no-mixed-operators
    const promoterVariance = (1 - npsScore) ** 2 * (promoters / totalResponses);
    // eslint-disable-next-line no-mixed-operators
    const neutralVariance = (0 - npsScore) ** 2 * (passive / totalResponses);
    // eslint-disable-next-line no-mixed-operators
    const detractorVariance = (-1 - npsScore) ** 2 * (detractors / totalResponses);
    const variance = promoterVariance + neutralVariance + detractorVariance;
    const standardError = Math.sqrt(variance) / Math.sqrt(totalResponses);

    return standardError * 1.96;
}

export function computeResponseRate ({ visitorsSeen, numResponses }) {
    if (visitorsSeen === 0) {
        return 0;
    }

    return numResponses / visitorsSeen;
}

export function npsColorByScore (score) {
    if (score >= 9) {
        return NPS_COLOR_MAP.promoters;
    }

    if (score >= 7) {
        return NPS_COLOR_MAP.passive;
    }

    return NPS_COLOR_MAP.detractors;
}

export function getResponseGroupByScore (score) {
    const parsedScore = parseInt(score, 10);

    const ratingGroup = npsFilters.rating.find((group) =>
        group.items.some((item) => parseInt(item.id, 10) === parsedScore),
    );

    return ratingGroup?.responseGroup?.slice(0, -1) || {};
}
